import React, { Component } from 'react'
import { connect } from 'react-redux'
// Dialog dependencies
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import $ from "jquery";
import Axios from 'axios'
import Translated from "../../../components/Translated/Translated";
import translator from "../../../utils/translator";

function isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}

export class ProjectTransferTableRow extends Component {
    state = {
        dialog: null,
        transfer_project_to_production: false, // Using to tell the program which server this project will be transferred to. 
        transfer_project_to_development: false // Using to tell the program which server this project will be transferred to.
    };
    // Now complete, I think
    toggleCheckBox = async (checkbox_name) => {
        switch (checkbox_name) {
            case "development":
                await this.setState({ transfer_project_to_development: !this.state.transfer_project_to_development, transfer_project_to_production: false })
                console.log("Development state ", this.state.transfer_project_to_development)
                $('#development').prop("checked", true);
                $('#production').prop("checked", false);
                break;

            case "production":
                await this.setState({ transfer_project_to_production: !this.state.transfer_project_to_production, transfer_project_to_development: false })
                console.log("Production state ", this.state.transfer_project_to_production)
                $('#development').prop("checked", false)
                $('#production').prop("checked", true);
                break;
            default: break;
        }
    }

    transfer_project = async () => {
        try {
            // Check which environmnet the user wants to transfer this project to
            let server = '';
            server = this.state.transfer_project_to_development ? "dev" : server;
            server = this.state.transfer_project_to_production ? "prod" : server;
            console.log("here is the value for the server variable ", server);
            console.log("here is the value for the project Id ", this.props);
            if(server === '') {
                let dialog = <Dialog open={true} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title set-price-dialog-header">
                        <Translated section="Admin Menu" label="project_transfer_title" />{" "}
                    </DialogTitle>
                    <DialogContent style={{ paddingRight: "10em" }}>
                        <React.Fragment>
                            <DialogContentText>
                                {translator("Admin Project Transfer", "unable_to_determine_server")}
                            </DialogContentText>
                            <Button style={{ marginLeft: "10em" }} id="set-price-close-button" onClick={() => this.setState({ 
                                dialog: null, 
                                transfer_project_to_production: false, 
                                transfer_project_to_development: false
                                })} color="primary">
                                <Translated section="Misc" label="ok_btn" />
                            </Button>
                        </React.Fragment>
                    </DialogContent>
                </Dialog>
                this.setState({ dialog });
            } else {
                let transfer_project_API_URL = this.props.API_URL + "/projects/transfer-project";
                let data = {
                    projectId: this.props.project_ID,
                    server: server,
                    trendId: localStorage.getItem('trendId'),
                    token: localStorage.getItem('token'),
                };
                console.log("here is the data object value before we send it to the backend ", data);
                let transfer_project_API_response = await Axios.post(transfer_project_API_URL, data);
                console.log(transfer_project_API_response.data.api_response.success);

                let dialog = <Dialog open={true} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title set-price-dialog-header">
                        <Translated section="Admin Menu" label="project_transfer_title" />{" "}
                    </DialogTitle>
                    <DialogContent style={{ paddingRight: "10em" }}>
                        <React.Fragment>
                            <DialogContentText>
                                {isObject(transfer_project_API_response.data.api_response) ? 
                                    transfer_project_API_response.data.api_response.success : 
                                    transfer_project_API_response.data.error}

                            </DialogContentText>
                            <Button style={{ marginLeft: "10em" }} id="set-price-close-button" onClick={() => this.setState({ 
                                dialog: null, 
                                transfer_project_to_production: false, 
                                transfer_project_to_development: false
                            })} color="primary">
                                <Translated section="Misc" label="ok_btn" />
                            </Button>

                        </React.Fragment>
                    </DialogContent>
                </Dialog>
                console.log("here is the API response when transferring project ", transfer_project_API_response);
                this.setState({ dialog });
            }
        } catch (error) {
            console.log("here is the error message when transferring a project", error.message);
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.state.dialog}
                <tr class="project-search-table-row">
                    <td id="tbody-header" scope="row">
                        {this.props.project_name}
                    </td>
                    <td>{this.props.warehouse_number}</td>
                    <td>{this.props.account_name}</td>
                    <td>{this.props.project_status}</td>
                    <td>
                        <button
                            onClick={() => this.setState({
                                dialog:
                                    <Dialog open={true} aria-labelledby="form-dialog-title">
                                        <DialogTitle id="form-dialog-title set-price-dialog-header">
                                            <Translated section="Admin Menu" label="project_transfer_title" />{" "}
                                        </DialogTitle>
                                        <DialogContent style={{ paddingRight: "10em" }}>
                                            <React.Fragment>
                                                <DialogContentText>
                                                    <table class="table table-bordered search-results-table checkbox-table">
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <h3 class="application-settings-sub-header"><Translated section="Admin Project Delete" label="server_dev" /></h3>
                                                                </td>
                                                                <td class="settings-checkbox-td">

                                                                    <input
                                                                        class="dn"
                                                                        type="checkbox"
                                                                        id="development"
                                                                        onChange={() => this.toggleCheckBox("development")}
                                                                        checked={this.state.transfer_project_to_development ? 1 : 0}
                                                                    />
                                                                    <label class="settings-label" htmlFor="development">
                                                                        <div class="settings-label-icon">&#10003;</div>
                                                                    </label>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <h3 class="application-settings-sub-header"><Translated section="Admin Project Delete" label="server_prod" /></h3>
                                                                </td>
                                                                <td class="settings-checkbox-td">
                                                                    <input
                                                                        class="dn"
                                                                        type="checkbox"
                                                                        id="production"
                                                                        onChange={() => this.toggleCheckBox("production")}
                                                                        checked={this.state.transfer_project_to_production ? false : 0}
                                                                    />
                                                                    <label class="settings-label" htmlFor="production">
                                                                        <div class="settings-label-icon">&#10003;</div>
                                                                    </label>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </DialogContentText>
                                                <Button style={{ marginLeft: "10em" }} id="set-price-close-button" onClick={() => this.setState({ 
                                                    dialog: null, 
                                                    transfer_project_to_production: false, 
                                                    transfer_project_to_development: false
                                                    })} color="primary">
                                                    <Translated section="Misc" label="cancel_btn" />
					                        </Button>
                                                <Button style={{ marginLeft: "10em" }} id="set-price-close-button" onClick={() => this.transfer_project()} color="primary">
                                                    <Translated section="Misc" label="transfer_label" />
					                        </Button>
                                            </React.Fragment>
                                        </DialogContent>
                                    </Dialog>
                            })}
                            type="button"
                            class="btn btn-outline-primary"
                            style={{ whiteSpace: "nowrap", paddingRight: "6em" }}
                        >
                            <Translated section="Misc" label="transfer_label" />
                        </button>
                    </td>
                </tr>
            </React.Fragment>
        );
    };
}

const mapStateToProps = (state) => ({
    API_URL: state.APIUrl
});

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectTransferTableRow);
